export const LISTING_NOT_READY_ERROR_CODE = 'Listing_is_not_ready_to_publish'

export const LISTING_PORTAL_NOT_CONNECTED_ERROR_CODE = 'Portal_not_connected'
